import { useEffect, useMemo, useState } from 'react';

/**
 * useMediaQuery Hook
 *
 * A custom React hook for detecting whether a media query matches the current viewport.
 * - Listens for changes to the media query and updates its state accordingly.
 *
 * @param {string} query - The media query string (e.g., '(min-width: 768px)').
 * @returns {boolean} - A boolean indicating whether the media query matches.
 */
export default function useMediaQuery(query) {
    const media = useMemo(() => window.matchMedia(query), [query]);

    const [matches, setMatches] = useState(media.matches);

    useEffect(() => {
        const listener = () => {
            setMatches(media.matches);
        };
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [media]);

    return matches;
}
